import React from 'react';
import ReactDOM from 'react-dom';
import './style/index.css'; // Import any CSS or styling files you have
import App from './App'; // Import your main App component
import {FirebaseProvider} from './FirebaseContext';

ReactDOM.render(
  <React.StrictMode>
    <FirebaseProvider>
    <App />
    </FirebaseProvider>
  </React.StrictMode>,
  document.getElementById('root') // This is where the React app is mounted in the index.html
);
